import { observer } from 'mobx-react-lite';
import { useEffect,useState } from 'react';
import { Card, Checkbox, Grid } from 'semantic-ui-react';
import {
  Template,
  TemplateSubTasks,
  WorkflowElement,
} from '../../../../app/models/template';
import { useStore } from '../../../../app/stores/store';
import { TemplateTask } from './../../../../app/models/template';
import '../../../../app/common/modals/mile.css';

interface Props {
  templateSelected: Template | undefined;
  name?:string;
}

function DashboardTemplateCard({ templateSelected,name }: Props) {
  const { dashboardStore,commonStore,userStore } = useStore();
  const [taskname, settaskname] = useState();
  const [subtaskname, setsubtaskname] = useState<string>();
  const [showSecondCard, setshowSecondCard] = useState(false);
  const [showThirdCard, setshowThirdCard] = useState(false);
  const [showFirst] = useState(true);
  const [active, setActive] = useState(false);
  const [showSubClickedCard, setShowSubClickedCard] = useState(false);
  const [showSubThirdClickedCard, setShowSubThirdClickedCard] = useState(false);
  const readOnlySelect = {
    pointerEvents: 'none', 
    opacity: '1'
  };

  const handledata = (e: any) => {
    settaskname((commonStore.RestorationCustomer && userStore?.user?.departmentName==='Restoration' && name === 'Sectionmaltiple') ? e : e?.currentTarget?.textContent);
    setShowSubClickedCard(true);
    setshowSecondCard(true);
    setActive(true);
    setshowThirdCard(false);
  };
  const handleSubData = (e: any) => {
    setsubtaskname(e.currentTarget.textContent);
    setshowThirdCard(true);
    setShowSubThirdClickedCard(true);
    setActive(true);
  };
  useEffect(()=>{
    if((commonStore.RestorationCustomer && userStore?.user?.departmentName==='Restoration' && name === 'Sectionmaltiple')){
     handledata('Restoration');
    }
    // eslint-disable-next-line
 },[])

  // Main Task
  const toggleOnTask = (event: any, data: any, index: number) => {
    // returns name of clicked component
    if (data.checked === false) {
      setshowSecondCard(false);
      setShowSubClickedCard(false);
      setshowThirdCard(false);
    }
    if (data.checked) {
      setshowSecondCard(true);
      setShowSubClickedCard(true);
      settaskname(event.currentTarget.getElementsByTagName('input')[0].name);
    }
    if (dashboardStore.dashboard.CreateOrderTemplate) {
      const temp = {
        ...dashboardStore.dashboard.CreateOrderTemplate,
        tasks: [...dashboardStore.dashboard.CreateOrderTemplate.tasks],
      };

      temp.tasks[index]['isActive'] = data.checked;
      dashboardStore.updateCreateOrderTemplate(temp);
      return temp;
    }
  };

  // SubTask
  const toggleOnSubTask = (
    event: any,
    data: any,
    taskIndex: number,
    subTaskIndex: number,
  ) => {
    if (event.currentTarget.getElementsByTagName('input')[0].checked) {
      setshowThirdCard(false);
    }
    if (
      event.currentTarget.getElementsByTagName('input')[0].checked === false
    ) {
      setshowThirdCard(true);
    }
    if (dashboardStore.dashboard.CreateOrderTemplate) {
      const temp = {
        ...dashboardStore.dashboard.CreateOrderTemplate,
        tasks: [...dashboardStore.dashboard.CreateOrderTemplate.tasks],
      };
      // change title "isActive" to "false"

      temp.tasks[taskIndex].subTasks[subTaskIndex]['isActive'] = data.checked;
      dashboardStore.updateCreateOrderTemplate(temp);
      return temp;
    }
  };

  const toggleOnElements = (
    event: any,
    data: any,
    taskIndex: number,
    subTaskIndex: number,
    elementIndex: number,
  ) => {
    if (dashboardStore.dashboard.CreateOrderTemplate) {
      const temp = {
        ...dashboardStore.dashboard.CreateOrderTemplate,
        tasks: [...dashboardStore.dashboard.CreateOrderTemplate.tasks],
      };
      // change title "isActive" to "false"
      temp.tasks[taskIndex].subTasks[subTaskIndex].elements[elementIndex][
        'isActive'
      ] = data.checked;
      dashboardStore.updateCreateOrderTemplate(temp);
      return temp;
    }
  };

  const cardcolor = { backgroundColor: 'lightgray', color: 'black' };
  const cardStyleLevel1 = {
    display: 'inline-block',
    padding: '10px',
    height: '22vh',
    width: '200pt',
    // marginLeft: '30px',
    // marginTop: '15px',
    color: 'black',
    cursor: 'pointer',
    overflowY: 'scroll',
  };
  const cardStyleLevel2 = {
    display: 'inline-block',
    padding: '10px',
    height: '20vh',
    width: '200pt',
    marginTop: '16px',
    marginLeft: '3px',
    color: 'black',
    cursor: 'pointer',
    overflowY: 'scroll',
  };
  const cardStyleLevel3 = {
    display: 'inline-block',
    padding: '10px',
    height: '18vh',
    width: '200pt',
    marginTop: '24px',
    marginLeft: '3px',
    color: 'black',
    cursor: 'pointer',
    overflowY: 'scroll',
  };

  return (
    <>
      <Grid>
        {showFirst === true ? (
          <Card style={cardStyleLevel1}>
            <Card style={(commonStore.RestorationCustomer && userStore?.user?.departmentName==='Restoration' && name === 'Sectionmaltiple') ? readOnlySelect : {} }>
              {templateSelected?.tasks?.map((task: any, index: number) => (
                <Card.Content
                  style={
                    active && task.taskName === taskname ? cardcolor : {}
                  }
                  key={index}
                >
                  <Grid className="hoverColor" columns={3}>
                    <Grid.Row>
                      <Grid.Column onClick={handledata} width={14}>
                        {task.taskName}
                      </Grid.Column>
                      <Grid.Column width={2} style={{ padding: '0' }}>
                        <Checkbox
                        readOnly={(commonStore.RestorationCustomer && userStore?.user?.departmentName==='Restoration' && name === 'Sectionmaltiple')}
                          key={index}
                          style={{
                            marginTop: '-3px',
                            marginLeft: '-10px',
                          }}
                          onChange={(e: any, data: any) =>
                            toggleOnTask(e, data, index)
                          }
                          name={task.taskName}
                          className="table-toggle"
                          toggle
                          defaultChecked={task.isActive ? true : false}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Card.Content>
              ))}
            </Card>
          </Card>
        ) : null}
        {showSecondCard && showSubClickedCard === true ? (
          <Card style={cardStyleLevel2}>
            <Card style={(commonStore.RestorationCustomer && userStore?.user?.departmentName==='Restoration' && name === 'Sectionmaltiple') ? readOnlySelect: {}}>
              {showSecondCard && showSubClickedCard === true
                ? templateSelected?.tasks?.map(
                    (tasks: TemplateTask, taskIndex: number) => (
                      <>
                        {taskname === tasks?.taskName
                          ? tasks.subTasks.map(
                              (
                                subtasks: TemplateSubTasks,
                                subTaskIndex: number,
                              ) => (
                                <Card.Content
                                  style={
                                    active &&
                                    subtasks.subTaskName === subtaskname
                                      ? cardcolor
                                      : {}
                                  }
                                  key={taskIndex}
                                >
                                  <Grid className="hoverColor" columns={3}>
                                    <Grid.Row>
                                      <Grid.Column
                                        onClick={handleSubData}
                                        width={14}
                                      >
                                        {subtasks.subTaskName}
                                      </Grid.Column>
                                      <Grid.Column
                                        width={2}
                                        style={{
                                          padding: '0',
                                        }}
                                      >
                                        <Checkbox
                                        readOnly={(commonStore.RestorationCustomer && userStore?.user?.departmentName==='Restoration' && name === 'Sectionmaltiple')}
                                          key={subTaskIndex}
                                          style={{
                                            marginTop: '-3px',
                                            marginLeft: '-10px',
                                          }}
                                          onClick={(e: any, data: any) =>
                                            toggleOnSubTask(
                                              e,
                                              data,
                                              taskIndex,
                                              subTaskIndex,
                                            )
                                          }
                                          name={subtasks.subTaskName}
                                          className="table-toggle"
                                          toggle
                                          defaultChecked={
                                            subtasks.isActive ? true : false
                                          }
                                        />
                                      </Grid.Column>
                                    </Grid.Row>
                                  </Grid>
                                </Card.Content>
                              ),
                            )
                          : null}
                      </>
                    ),
                  )
                : null}
            </Card>
          </Card>
        ) : null}
        {showSecondCard && showThirdCard && showSubThirdClickedCard === true ? (
          <Card style={cardStyleLevel3}>
            <Card>
              {templateSelected?.tasks?.map(
                (tasks: TemplateTask, taskIndex: number) => (
                  <>
                    {taskname === tasks.taskName
                      ? tasks.subTasks.map(
                          (
                            subtasks: TemplateSubTasks,
                            subTaskIndex: number,
                          ) => (
                            <>
                              {subtaskname === subtasks.subTaskName
                                ? subtasks.elements.map(
                                    (
                                      elements: WorkflowElement,
                                      elementIndex: number,
                                    ) => (
                                      <Card.Content>
                                        <Grid
                                          className="hoverColor"
                                          columns={3}
                                        >
                                          <Grid.Row>
                                            <Grid.Column width={14}>
                                              {elements.elementName}
                                            </Grid.Column>
                                            <Grid.Column
                                              width={2}
                                              style={{
                                                padding: '0',
                                              }}
                                            >
                                              <Checkbox
                                                key={elementIndex}
                                                style={{
                                                  marginTop: '-3px',
                                                  marginLeft: '-10px',
                                                }}
                                                onClick={(e: any, data: any) =>
                                                  toggleOnElements(
                                                    e,
                                                    data,
                                                    taskIndex,
                                                    subTaskIndex,
                                                    elementIndex,
                                                  )
                                                }
                                                name={elements.elementName}
                                                className="table-toggle"
                                                toggle
                                                defaultChecked={
                                                  elements.isActive
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </Grid.Column>
                                          </Grid.Row>
                                        </Grid>
                                      </Card.Content>
                                    ),
                                  )
                                : null}
                            </>
                          ),
                        )
                      : null}
                  </>
                ),
              )}
            </Card>
          </Card>
        ) : null}
      </Grid>
    </>
  );
}
export default observer(DashboardTemplateCard);
